<template>
    <div>
        <div class="col-md-12">
            <div class="card card-primary card-outline card-outline-tabs">
                <div class="card-header p-0 border-bottom-0">
                    <ul
                        class="nav nav-tabs nav-pills nav-fill"
                        id="custom-tabs-four-tab"
                        role="tablist"
                    >
                        <li class="nav-item">
                            <a
                                class="nav-link active"
                                id="custom-tabs-four-cascade-tab"
                                data-toggle="pill"
                                href="#custom-tabs-four-cascade"
                                role="tab"
                                aria-controls="custom-tabs-four-cascade"
                                aria-selected="false"
                                >Cascade</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                id="custom-tabs-four-nsep-tab"
                                data-toggle="pill"
                                href="#custom-tabs-four-nsep"
                                role="tab"
                                aria-controls="custom-tabs-four-nsep"
                                aria-selected="true"
                                >NSEP</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                id="custom-tabs-four-vcct-tab"
                                data-toggle="pill"
                                href="#custom-tabs-four-vcct"
                                role="tab"
                                aria-controls="custom-tabs-four-vcct"
                                aria-selected="false"
                                >HTS</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                id="custom-tabs-four-SMZ-tab"
                                data-toggle="pill"
                                href="#custom-tabs-four-SMZ"
                                role="tab"
                                aria-controls="custom-tabs-four-SMZ"
                                aria-selected="false"
                                >PLHIV</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                id="custom-tabs-four-spouse-tab"
                                data-toggle="pill"
                                href="#custom-tabs-four-spouse"
                                role="tab"
                                aria-controls="custom-tabs-four-spouse"
                                aria-selected="false"
                                >Spouse</a
                            >
                            
                        </li>
                        
                    </ul>
                </div>
                <!-- /.card -->
                <div class="col-md-12">
                    <div class="card-body">
                        <div
                            class="tab-content"
                            id="custom-tabs-four-tabContent"
                        >
                        <div
                                class="tab-pane fade active show"
                                id="custom-tabs-four-cascade"
                                role="tabpanel"
                                aria-labelledby="custom-tabs-four-cascade-tab"
                            >
                                <general-indicators></general-indicators>
                                
                                <positive-map></positive-map>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="custom-tabs-four-nsep"
                                role="tabpanel"
                                aria-labelledby="custom-tabs-four-nsep-tab"
                            >
                                <nsep-indicators></nsep-indicators>
                                <nsep-map></nsep-map>
                                
                                <!-- <city-wise-registration></city-wise-registration> -->
                            </div>
                            <div
                                class="tab-pane fade"
                                id="custom-tabs-four-vcct"
                                role="tabpanel"
                                aria-labelledby="custom-tabs-four-vcct-tab"
                            >
                                <htc-indicators></htc-indicators>
                                <htc-map></htc-map>
                                <city-wise-reactive></city-wise-reactive>
                                <city-wise-vcct-tested></city-wise-vcct-tested>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="custom-tabs-four-SMZ"
                                role="tabpanel"
                                aria-labelledby="custom-tabs-four-SMZ-tab"
                            >
                                <smz-indicators></smz-indicators>
                                <smz-map></smz-map>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="custom-tabs-four-spouse"
                                role="tabpanel"
                                aria-labelledby="custom-tabs-four-spouse-tab"
                            >
                                <spouse-indicators></spouse-indicators>
                                <spouse-map></spouse-map>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HTCIndicators from "./../indicators/HTCIndicators";
import SMZIndicators from "./../indicators/SMZIndicators";
import NSEPIndicators from "./../indicators/NSEPIndicators";
import SpouseIndicators from "./../indicators/SpouseIndicators";
import PositiveMap from "./PositiveMap.vue";
import CityWiseRegistration from '../charts/CityWiseRegistration.vue';
import CityWiseReactive from '../charts/CityWiseReactive.vue';
import CityWiseVcctTested from '../charts/CityWiseVcctTested.vue';
import BubbleChart from '../charts/nsep/BubbleChart.vue';
import SpouseMap from './SpouseMap.vue';
import GeneralIndicators from '../indicators/GeneralIndicators.vue';
import NSEPMap from './NSEPMap.vue';
import HtcMap from './HtcMap.vue';
import SmzMap from './SmzMap.vue';
export default {
    name: "component-indicators",
    components: {
        "smz-indicators": SMZIndicators,
        "nsep-indicators": NSEPIndicators,
        "htc-indicators": HTCIndicators,
        "spouse-indicators": SpouseIndicators,
        "positive-map": PositiveMap,
        CityWiseRegistration,
        CityWiseReactive,
        CityWiseVcctTested,
        BubbleChart,
        SpouseMap,
        GeneralIndicators,
        "nsep-map" : NSEPMap,
        HtcMap,
        SmzMap,
    },
    data() {
        return {
            sitename: null,
            chart: null,
            chartSpouse: null,
        }
    },
    methods: {
        
    }
};
</script>

<style lang="scss" scoped></style>